import React from "react";
import { Router, Link, Fragment } from "react-static";
import { hot } from "react-hot-loader";
import styled, { createGlobalStyle } from "styled-components";

import "typeface-raleway";

import Routes from "react-static-routes";

const GlobalStyle = createGlobalStyle`
	body {
		margin: 0;
		padding: 0;
		font-family: "Raleway", sans-serif;
	}
`;

const App = () => (
  <div>
    <GlobalStyle />
    <Router>
      <Routes />
    </Router>
  </div>
);

export default hot(module)(App);



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js